import lodash from 'lodash';
import * as log from './log';
import * as types from './types';
import * as formatter from './formatter';
import * as parser from './parser';

const libs = {
  // 所有与log相关的内容
  log,
  // 所有与类型相关的内容
  types,
  // 所有与lodash相关的内容
  lodash,
  // 所有与格式化相关的内容
  formatter,
  // 所有与类型转换相关的内容
  parser,
  // 所有与错误处理相关的内容
  error: {},
  // 所有与HTTP请求处理相关的内容
  http: {}
};

/**
 * $xpc属性下定义的所有命名空间
 */
const namespaces = Object.keys(libs).map(prop => `$${prop}`);

export default {
  name: 'xpcPlugin',

  // 插件是否自动安装
  autoInstall: true,

  install (Vue, options) {
    // 生成对应的$xpc对象
    const $xpc = namespaces.reduce((obj, prop) => ((obj[prop] = libs[prop.replace('$', '')]), obj), {});

    // 冻结$xpc对象，防止$xpc中的属性在项目中被覆写
    Object.freeze($xpc);

    /**
     * 通过代理模式，可以无需填写命名空间，直接调用属性
     * 例：$xpc.$log.warning 函数，可以直接通过 $xpc.warning进行访问
     */
    Vue.prototype.$xpc = new Proxy($xpc, {
      get (target, key) {
        if (key.startsWith('$')) {
          return target[key];
        } else {
          const targetProp = namespaces.find(prop => target[prop].hasOwnProperty(key));
          return targetProp ? target[targetProp][key] : undefined;
        }
      }
    });

    // Vue.prototype.$xpc 不允许删除、不允许被覆写
    Object.defineProperty(Vue.prototype, '$xpc', { writable: false, configurable: false });
  }
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/plugins/xpc/index.js